export const getRegionChildTypeName = (regionName, continents) => {
  return continents.find(continent => continent.name === regionName)
    ? "Country"
    : regionName === "Canada"
    ? "Province/Territory"
    : regionName === "United States"
    ? "State"
    : "Region"
}
